export enum AirConditioningMode {
  FREDDO = 'FREDDO',
  CALDO = 'CALDO',
  FREDDO_CALDO = 'FREDDO_CALDO',
}
